export enum InvoiceRunForms {
  GenerateExport = 'GenerateExport',
  SendInvoices = 'SendInvoices',
}
